import { FormattedMessage } from 'react-intl';
import { ELSButton, ELSFlex, ELSIcon, ELSTab, ELSTabGroup } from 'components/common/els';
import NavigationComponent from 'components/common/navigation-component/NavigationComponent';
import { CaseStudyLanguageKeys } from 'lang/caseStudy';
import { NavigateProps, Tabs } from './AssignmentCommonInfo';
import AssignmentCommonOverview from './AssignmentCommonOverview';
import Instruction from './Instruction';
import './assignment.common.info.scss';
import { AssignmentType } from 'models/enum';

export interface AssignmentCommonInfoViewProps {
  activeTab: number;
  markPhaseDoneIsDisabled: boolean;
  onMarkPhaseDoneClick: () => void;
  onTabGroupClick: (tabIndex: number) => void;
  overview: string;
  markPhaseDoneText: string;
  instruction: string;
  navigateProps: NavigateProps;
  assignmentType: string;
}

const AssignmentCommonInfoView = (props: AssignmentCommonInfoViewProps) => {
  const title = props.assignmentType === AssignmentType.SIMULATION ? 'Simulation EHR' : 'Case Study';
  return (
    <div className="assignment-common-info">
      <ELSFlex className={`assignment-common-info__header ${props.assignmentType === AssignmentType.SIMULATION ? 'assignment-common-info__header-simulation' : ''}`} middle column center>
        <ELSButton
          iconSize="1x"
          iconName="checkmark"
          iconPosition="left"
          text={props.markPhaseDoneText}
          onClick={props.onMarkPhaseDoneClick}
          isDisabled={props.markPhaseDoneIsDisabled}
        />
        {props.assignmentType === AssignmentType.CASE_STUDY && <ELSFlex className="u-els-margin-top">
          <ELSIcon name="alert" prefix="gizmo" size="2x" align="sub" />
          <p className="note">
            <FormattedMessage id={CaseStudyLanguageKeys.CASE_STUDY_INFO.WARNING_MARK_PHASE_1_DONE} />
          </p>
        </ELSFlex>}
      </ELSFlex>
      <h2 className="assignment-common-info__title u-els-margin-top-3o2 u-els-margin-bottom-1o2 u-els-margin-2x u-els-margin-1x@desktop">{`${title} Information`}</h2>
      <NavigationComponent
        className="u-els-margin-top-1x u-els-margin-bottom-1x u-els-margin-2x u-els-margin-1x@desktop"
        title="Phase"
        current={props.navigateProps.current}
        total={props.navigateProps.total}
        onPrev={props.navigateProps.onPrev}
        onNext={props.navigateProps.onNext}
        disableNext={props.navigateProps.disableNext}
      />
      <div className="assignment-common-info__tab-group">
        <ELSTabGroup autoFocusTab={false} onChangeActiveIndex={props.onTabGroupClick} activeIndex={props.activeTab}>
          <ELSTab title="Instructions" />
          <ELSTab title={`${title} Overview`} />
        </ELSTabGroup>
      </div>
      <div className="u-els-margin-2x u-els-margin-1x@desktop">
        {props.activeTab === Tabs.INSTRUCTIONS && <Instruction instruction={props.instruction} />}
        {props.activeTab === Tabs.CASE_STUDY_OVERVIEW && <AssignmentCommonOverview overview={props.overview} />}
      </div>
    </div>
  );
};

AssignmentCommonInfoView.displayName = 'AssignmentCommonInfoView';
export default AssignmentCommonInfoView;
